import { Controller } from "@hotwired/stimulus"
import { VisitHelper } from "~/helpers/visit_helper"

export default class extends Controller {
  connect() {
    this.frames = ["usage_history"]
  }

  applyDateRange({ detail: { startDate, endDate, range } }) {
    let params = {
      range: range,
      start_date: startDate,
      end_date: endDate
    }

    VisitHelper.update(this.frames, params)
  }

  applyFilter({ detail: { name, value } }) {
    let params = {}

    params[name] = value

    if (name === "user_id") {
      params["user_role"] = ""
    }

    if (name === "user_role") {
      params["user_id"] = ""
    }

    VisitHelper.update(this.frames, params)
  }
}
